export const STATE_MAPS = [
    //{ name: "Maharashtra", mapName: "Maharashtra" },
    { name: "Andaman and Nicobar Islands", mapName: "andamannicobarislands" },
    { name: "Andhra Pradesh", mapName: "andhrapradesh" },
    { name: "Arunachal Pradesh", mapName: "arunachalpradesh" },
    { name: "Assam", mapName: "assam" },
    { name: "Bihar", mapName: "bihar" },
    { name: "Chandigarh", mapName: "chandigarh" },
    { name: "Chhattisgarh", mapName: "chhattisgarh" },
    { name: "Delhi", mapName: "delhi" },
    { name: "Dadra and Nagar Haveli and Daman and Diu", mapName: "dnh-and-dd" },
    { name: "Goa", mapName: "goa" },
    { name: "Gujarat", mapName: "gujarat" },
    { name: "Haryana", mapName: "haryana" },
    { name: "Himachal Pradesh", mapName: "himachalpradesh" },
    //{ name: "India", mapName: "india" },
    { name: "Jammu and Kashmir", mapName: "jammukashmir" },
    { name: "Jharkhand", mapName: "jharkhand" },
    { name: "Karnataka", mapName: "karnataka" },
    { name: "Kerala", mapName: "kerala" },
    { name: "Ladakh", mapName: "ladakh" },
    { name: "Lakshadweep", mapName: "lakshadweep" },
    { name: "Madhya Pradesh", mapName: "madhyapradesh" },
    { name: "Maharashtra", mapName: "maharashtra" },
    { name: "Manipur", mapName: "manipur" },
    { name: "Meghalaya", mapName: "meghalaya" },
    { name: "Mizoram", mapName: "mizoram" },
    { name: "Nagaland", mapName: "nagaland" },
    { name: "Odisha", mapName: "odisha" },
    { name: "Puducherry", mapName: "puducherry" },
    { name: "Punjab", mapName: "punjab" },
    { name: "Rajasthan", mapName: "rajasthan" },
    { name: "Sikkim", mapName: "sikkim" },
    { name: "Tamil Nadu", mapName: "tamilnadu" },
    { name: "Telangana", mapName: "telangana" },
    { name: "Tripura", mapName: "tripura" },
    { name: "Uttarakhand", mapName: "uttarakhand" },
    { name: "Uttar Pradesh", mapName: "uttarpradesh" },
    { name: "West Bengal", mapName: "westbengal" },
];

export const COUNTRY_MAPS = [
    { name: "India", mapName: "india" }
];